export default __webpack_public_path__ + "static/media/009-first-aid-kit.cae1a994.png";